
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LtiService } from '../../../services/lti/lti.service';
import { firstValueFrom } from 'rxjs';

import {signIn, confirmSignIn, signOut , fetchAuthSession } from 'aws-amplify/auth'
import { getUsername } from '../../../services/users/users.model';
import { PreferencesService } from '../../../services/preferences/preferences.service';
import { UserStore } from '../../../stores/users.store';

@Component({
  selector: 'app-lti-launch',
  imports: [],
  templateUrl: './lti-launch.component.html',
  styleUrl: './lti-launch.component.css'
})
export class LtiLaunchComponent implements OnInit {

  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);
  readonly lti = inject(LtiService);
  readonly preferences = inject(PreferencesService);
  readonly userStore = inject(UserStore) ;

  
  async ngOnInit() {

    const ltik = this.route.snapshot.queryParams['ltik'] ;

    const launch = await firstValueFrom(this.lti.handleLaunch(ltik)) ;

    const session = await fetchAuthSession() ;
    if (session) {
      await signOut() ;
    }

    const { nextStep } = await signIn({
      username: getUsername(launch.user.email),
      options: {
        authFlowType: 'CUSTOM_WITHOUT_SRP',
      },
    });

    if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE') {
      try {

        let code = await firstValueFrom(this.lti.getOnetimeCode(ltik));
        await confirmSignIn({ challengeResponse: code.code });
      } catch (err) {
        console.log(err);
      }
    }

    await this.userStore.load() ;

    if (launch.role) {
      this.preferences.userType.set('teacher') ;
      await this.router.navigate(['admin','courses',launch.course.id]) ;
    } else if (launch.enrollment) {
      this.preferences.userType.set('student') ;
      await this.router.navigate(['student','courses',launch.course.id]) ;
    } else {
      console.log("HUh?")
    }



  }

}
